export default "__VITE_ASSET__CX7buW1q__"